module.exports = ".stepper{color:#647c9c}.stepButton{cursor:pointer;font-weight:bold}.stepButtonDisabled{cursor:default;font-weight:bold;color:grey}\n"